import React from 'react';
import PC from './PC';
import Mobile from './Mobile';

export default class App extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let width = window.outerWidth;
        return (width < 769 ? <Mobile /> : <PC />)
    }
}